import React, { useState } from "react";
import { Link } from "gatsby";
import { Logo } from "../../lan/image";
import { setEnglishLanguagePreference } from "../JapanGeoRedirect";

const JapanNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar navbar-expand-lg fixed-top jl-navbar">
      <Link className="navbar-brand" to="/jp/">
        <img src={Logo.default} alt="Koderbox" />
      </Link>

      <button
        className="navbar-toggler"
        type="button"
        onClick={() => setIsOpen((v) => !v)}
      >
        <i className={`fa ${isOpen ? "fa-times" : "fa-bars"}`} aria-hidden="true" />
      </button>

      <div
        id="navbarText"
        className={`collapse navbar-collapse ${isOpen ? "show jl-navbar-open" : ""}`}
      >
        <ul className="navbar-nav">
          <li className="nav-item">
            <Link className="nav-link" to="/jp/">
              ホーム
            </Link>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="/jp/#jl-courses">
              日本語コース
            </a>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="/jp/#jl-courses">
              英会話コース
            </a>
          </li>
          <li className="nav-item">
            <Link className="nav-link" to="/jp/corporate/">
              法人・企業向け
            </Link>
          </li>
          <li className="nav-item">
            <a className="nav-link" href="/jp/#jl-demo-form">
              お問い合わせ
            </a>
          </li>
          <li className="nav-item jl-navbar__lang">
            <a className="nav-link" href="/" onClick={setEnglishLanguagePreference}>
              🇬🇧 English Site
            </a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default JapanNavbar;
